module.exports = __webpack_public_path__ + "img/programs.3cb781e6.svg";